import React from 'react';

export const QuoteIcon = () => {
  return (
    <svg
      width="31"
      height="27"
      viewBox="0 0 31 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '31px', height: '27px', fill: '#289E46' }}
    >
      <path
        d="M12.323 0L7.50932 19.6452L6.35404 14.0323C8.21532 14.0323 9.75569 14.6129 10.9752 15.7742C12.1946 16.9355 12.8043 18.4839 12.8043 20.4194C12.8043 22.3548 12.1946 23.9355 10.9752 25.1613C9.75569 26.3871 8.24741 27 6.45031 27C4.58903 27 3.04865 26.3871 1.82919 25.1613C0.609731 23.871 0 22.2903 0 20.4194C0 19.7742 0.0320909 19.1613 0.096273 18.5806C0.224637 18 0.417184 17.3226 0.673913 16.5484C0.930642 15.7097 1.28364 14.7097 1.73292 13.5484L6.25776 0H12.323ZM30.5186 0L25.705 19.6452L24.5497 14.0323C26.411 14.0323 27.9513 14.6129 29.1708 15.7742C30.3903 16.9355 31 18.4839 31 20.4194C31 22.3548 30.3903 23.9355 29.1708 25.1613C27.9513 26.3871 26.4431 27 24.646 27C22.7847 27 21.2443 26.3871 20.0248 25.1613C18.8054 23.871 18.1957 22.2903 18.1957 20.4194C18.1957 19.7742 18.2277 19.1613 18.2919 18.5806C18.4203 18 18.6128 17.3226 18.8696 16.5484C19.1263 15.7097 19.4793 14.7097 19.9286 13.5484L24.4534 0H30.5186Z"
        fill="#289E46"
      />
    </svg>
  );
};
